import { render, staticRenderFns } from "./roleAuthorizationSon.vue?vue&type=template&id=51e75621&"
import script from "./roleAuthorizationSon.vue?vue&type=script&lang=js&"
export * from "./roleAuthorizationSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports